<div class="bg-background-secondary">
  <app-global-page-header [title]="title | translate">
    <div slot="end">
      <ion-button
        color="medium"
        fill="clear"
        shape="round"
        (click)="closeModal()"
      >
        <i class="fa-solid fa-times"></i>
      </ion-button>
    </div>
  </app-global-page-header>
</div>

<ion-content>
  <div>
    <ion-list lines="none">
      @for (item of this.list; track item.ref) {
        <ion-item
          class="pointer-hover py-1 px-4"
          (click)="selectItem(item.ref)"
        >
          <ion-label>
            <span [class.color-primary]="selectedValue === item.ref">
              {{ item.label | translate }}
            </span>
          </ion-label>

          @if (selectedValue === item.ref) {
            <div slot="end" class="color-primary">
              <i class="fa-regular fa-check"></i>
            </div>
          }
        </ion-item>
      }
    </ion-list>
  </div>
</ion-content>

<ion-footer>
  <div class="bg-background-secondary" style="height: 2px"></div>
  <div class="p-3">
    <div class="row">
      <div class="col-6 text-start">
        <ion-button
          expand="block"
          fill="outline"
          color="medium"
          (click)="closeModal()"
        >
          {{ 'generic.cancel' | translate }}
        </ion-button>
      </div>
      <div class="col-6 text-end">
        <ion-button expand="block" color="primary" (click)="confirmSelection()">
          {{ 'generic.confirm' | translate }}
        </ion-button>
      </div>
    </div>
  </div>
</ion-footer>
